import { Button } from "@/components/ui/button";

interface WithdrawButtonProps {
  onWithdraw: () => void;
  isLoading: boolean;
}

export const WithdrawButton = ({ onWithdraw, isLoading }: WithdrawButtonProps) => {
  return (
    <Button
      onClick={onWithdraw}
      className="w-full"
      disabled={isLoading}
      variant="secondary"
    >
      {isLoading ? "Withdrawing..." : "Withdraw Rewards"}
    </Button>
  );
};